import { useState, useEffect } from 'react';
import axiosClient from "../service/axiosClient";

export const useContractorsData = (periodStart) => {
    const [plants, setPlants] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        let isMounted = true;
        setIsLoading(true);
        setError(null);
        
        const fetchData = async () => {
            try {
                let formattedPeriodStart = null;
                if (periodStart) {
                    const newPeriodStart = new Date(periodStart.getTime());
                    newPeriodStart.setUTCHours(0, 0, 0, 0);
                    formattedPeriodStart = newPeriodStart.toISOString();
                }
                    
                const response = await axiosClient.get("/api/contractors_new", {
                    params: { periodStart: formattedPeriodStart }
                });
                
                if (isMounted) {
                    setPlants(response.data.plants.map(plant => ({ ...plant })) || []);
                    setIsLoading(false);
                }
            } catch (error) {
                console.error('Error fetching contractors:', error);
                if (isMounted) {
                    setError('Failed to load data. Please try again.');
                    setIsLoading(false);
                }
            }
        };

        fetchData();
        
        return () => {
            isMounted = false;
        };
    }, [periodStart]);

    return { plants, isLoading, error };
};

export default useContractorsData;
